import { useState } from "react";
import { Link } from "react-router-dom";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";

const DISCLAIMER_TEXT = `This "Unicators" is an educational website. The term “We”, “Us”, “Our” shall mean Unicators When you visit the Website and/or use any of the services provided by Us through any source of the Website or online presence, You will be subject to the rules, guidelines, policies, terms, and conditions applicable to such service, and they shall be deemed to be incorporated into this Terms of Use or privacy policy or Disclaimer and shall be considered as agreed. We reserve the right, at our sole discretion, to change, modify, add or remove the content partially or completely without any prior notice to the anybody, it is your responsibility to review these Terms of Use (TOI) /privacy policy or Disclaimer before using or accessing this website or any information from Unicators.com/Website. We will not be liable to you in any way or in relation to the Contents of, or use of, or otherwise in connection with, the www.Unicators.com does not warrant that this site; information, Content, materials, product (including software/marketing campaigns) or services included on or otherwise made available to you through the Website; their servers; or electronic communication sent from Us are free of viruses or other harmful components. 
Source of content may be copied from respective College / Universities/Govt Official sites and we may not be Authorized with all the listed college/universities/Boards. 
Its solely wish of visitor if they ask any Guidance / Assistance from us. All the contents of this website are only for general information or general use. They do not constitute advice and should not be relied upon in making (or refraining from making) any decision. Any specific advice or replies to queries in any part of the Site is/are the personal opinion of such experts/consultants/persons and are not subscribed to by this Site. All the information (including information about colleges, universities, institutions, exams, events etc) on www.Unicators.com has been compiled from the respective websites available in the public domain. While every possible care has been taken while creating and compiling the contents and materials, we do not take responsibility for the genuineness and authenticity of the contents and materials so provided. Users are advised to check the original (source) websites in case of any doubts.`;

export default function Footer() {
  const [showDisclaimer, setShowDisclaimer] = useState(false);
  return (
    <footer className="w-full border-t border-zinc-200 bg-[#F4F4F5] py-4 sm:py-6" data-testid="footer">
      {/* Our Associates */}
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 mb-4 sm:mb-6" data-testid="footer-associates">
        <p className="text-[10px] sm:text-xs font-['IBM_Plex_Mono'] font-bold uppercase tracking-wider text-[#09090B] mb-2">
          Our Associates
        </p>
        <div className="rounded-xl border border-zinc-200 bg-white px-4 py-3 inline-flex flex-col gap-0.5" data-testid="associate-unir">
          <span className="text-[10px] sm:text-xs font-semibold uppercase tracking-wide text-[#6043EF]">
            North East Associate
          </span>
          <span className="text-sm font-bold text-[#09090B]">UNIR Consultancy</span>
          <span className="text-[11px] sm:text-xs text-[#52525B]">
            Phone:{" "}
            <a href="tel:9435120555" className="font-semibold hover:text-[#6043EF] transition-colors" data-testid="associate-phone-1">9435120555</a>
            {" / "}
            <a href="tel:9738921727" className="font-semibold hover:text-[#6043EF] transition-colors" data-testid="associate-phone-2">9738921727</a>
          </span>
        </div>
      </div>

      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-1 border-t border-zinc-200 pt-4 sm:pt-6">
        <p className="text-[10px] sm:text-xs font-sans text-[#52525B] tracking-wide">
          Unicators — NEET College Counselling & Prediction Platform
        </p>
        <div className="flex items-center gap-4">
          <Link
            to="/about"
            data-testid="footer-about-link"
            className="text-[10px] sm:text-xs font-['IBM_Plex_Mono'] font-semibold text-[#52525B] hover:text-[#6043EF] transition-colors"
          >
            About
          </Link>
          <span className="text-zinc-300 text-xs">·</span>
          <button
            type="button"
            onClick={() => setShowDisclaimer(true)}
            data-testid="footer-disclaimer-link"
            className="text-[10px] sm:text-xs font-['IBM_Plex_Mono'] font-semibold text-[#52525B] hover:text-[#6043EF] transition-colors"
          >
            Disclaimer
          </button>
        </div>
      </div>

      <Dialog open={showDisclaimer} onOpenChange={setShowDisclaimer}>
        <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto" data-testid="disclaimer-dialog">
          <DialogHeader>
            <DialogTitle className="text-2xl font-bold tracking-tight text-[#09090B]">Disclaimer</DialogTitle>
          </DialogHeader>
          <div className="mt-2 space-y-4 text-sm leading-relaxed text-[#3f3f46]">
            {DISCLAIMER_TEXT.split("\n").map((para, i) => (
              <p key={i}>{para.trim()}</p>
            ))}
          </div>
        </DialogContent>
      </Dialog>
    </footer>
  );
}
